import moment from "moment";
import { confirmDialog } from "../popups/ConfirmDialog";
import { Localize } from "../../app/lang/langs";
import { countShiftsAfterMissionEnd } from "./teamsSlice";

/**
 * Asks before a mission end date is saved: the back end erases the collab's shifts in the team
 * after that date (leaves and work stoppages are kept). Shows how many, from
 * /v1/teams/countShiftsAfterMissionEnd.
 *
 * @param {Function} dispatch
 * @param {{ id_mission, end_date, id_team? }} mission end_date as sent to editCollabMission
 * @returns {Promise<boolean>} whether the user confirmed
 */
export async function confirmMissionEnd(dispatch, { id_mission, end_date, id_team }) {
  let count = "?";
  try {
    const action = await dispatch(countShiftsAfterMissionEnd({ id_mission, end_date, id_team }));
    const data = action.payload && action.payload.responseData;
    if (data && data.status) count = data.count;
  } catch (error) {
    console.error(error);
  }

  return new Promise((resolve) => {
    let settled = false;
    const settle = (value) => {
      if (settled) return;
      settled = true;
      resolve(value);
    };
    confirmDialog({
      title: Localize("MISSION_END_SHIFTS_TITLE"),
      message: Localize("MISSION_END_SHIFTS_MSG")
        .replace("%DATE%", moment(end_date).format("DD/MM/YYYY"))
        .replace("%COUNT%", count),
      // Shifts are erased: a destructive answer.
      danger: true,
      confirmLabel: Localize("YES"),
      cancelLabel: Localize("NO"),
      onConfirm: () => settle(true),
      onHide: () => settle(false),
    });
  });
}
